import { Vector3 as BABYLON_Vector3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { PostProcess as BABYLON_PostProcess } from '@inter-ikea-betrakta-babylonjs/core/PostProcesses/postProcess.js';
import { Camera as BABYLON_Camera } from '@inter-ikea-betrakta-babylonjs/core/Cameras/camera.js';
// Side effect
import '../shaders/view_compositor.fragment.js';
import { IVector2 } from '../../api.js';
const VIEW_POSITION = 'viewPosition';
const VIEW_SIZE = 'viewSize';
const VIEW_TEXTURE = 'viewTexture';
/**
 * This is a class to assist the Viewer with compositing Views and their outlines onto a framebuffer (in the Viewer's case, the canvas)
 * Future use might be to assist with rendering borders, drop shadows etc for the Views compositing.
 */
export class ViewCompositor {
    constructor(scene) {
        this._current_view = null;
        this._scene = scene;
        this._post_process_camera = new BABYLON_Camera('ViewCompositorPP', new BABYLON_Vector3(), this._scene);
        this._effect = new BABYLON_PostProcess('view_compositor', 'view_compositor', [
            VIEW_POSITION, VIEW_SIZE
        ], [
            VIEW_TEXTURE
        ], { width: 4, height: 4 }, this._post_process_camera);
        this._effect.onApply = (effect) => {
            const target_width = this._scene.getEngine().getRenderWidth();
            const target_height = this._scene.getEngine().getRenderHeight();
            effect.setTexture(VIEW_TEXTURE, this._current_view.postprocess_manager.get_destination_texture());
            const viewport = this._current_view.get_canvas_viewport();
            const normalized_width = viewport.width / target_width;
            const normalized_height = viewport.height / target_height;
            const normalized_x = viewport.x / target_width;
            const normalized_y = viewport.y / target_height;
            effect.setFloat2(VIEW_POSITION, normalized_x, 1.0 - normalized_y - normalized_height);
            effect.setFloat2(VIEW_SIZE, normalized_width, normalized_height);
        };
    }
    render(view, outlines) {
        const canvas_viewport = view.get_canvas_viewport();
        if ((canvas_viewport.x >= this._scene.getEngine().getRenderWidth() ||
            canvas_viewport.x + canvas_viewport.width <= 0) &&
            (canvas_viewport.y >= this._scene.getEngine().getRenderHeight() ||
                canvas_viewport.y + canvas_viewport.height <= 0)) {
            // Early out as we're outside the target viewport
            return;
        }
        this._current_view = view;
        // It may feel wasteful to have the "doNotBindFramebuffer" set to false, as we don't want to swap around any framebuffers.
        // However, we got some issues with Babylon applying the incorrect GL viewport otherwise.
        // It felt nicer to let Babylon to do its thing, rather than messing with the GL state directly (reapplying glViewport between every draw)
        this._scene.postProcessManager.directRender([this._effect], null, true, undefined, undefined, false);
        this._current_view = null;
        if (outlines !== null && view.outlines_enabled) {
            // Remove all jitter from the engine camera temporarily for the outlines rendering.
            // This is a temporary fix until we move outlines rendering onto views (and thus give them TAA)
            const jitter = view.engine_camera.get_jitter();
            view.engine_camera.set_jitter(new IVector2(0, 0));
            outlines.render_outline_ontop_of_main(view.engine_camera.camera, null, canvas_viewport.width, canvas_viewport.height, canvas_viewport.x, this._scene.getEngine().getRenderHeight() - canvas_viewport.height - canvas_viewport.y);
            view.engine_camera.set_jitter(jitter);
        }
    }
}
//# sourceMappingURL=ViewCompositor.js.map